import { create } from "zustand";
import type { OwnerVoiceSettings, VoiceTonePreset } from "../api/voiceSettings";

export interface VoiceSettingsDraft {
  tone_preset: VoiceTonePreset;
  chat_greeting: string;
  assistant_greeting: string;
  tone_custom_instructions: string;
}

export interface VoiceSettingsSlice {
  draft: VoiceSettingsDraft | null;
  isDirty: boolean;
  fieldErrors: Record<string, string>;
  formError: string | null;
  initDraft: (settings: OwnerVoiceSettings) => void;
  updateDraft: (patch: Partial<VoiceSettingsDraft>) => void;
  setFieldErrors: (errors: Record<string, string>) => void;
  setFormError: (error: string | null) => void;
  resetDraft: () => void;
}

export const useVoiceSettingsStore = create<VoiceSettingsSlice>((set) => ({
  draft: null,
  isDirty: false,
  fieldErrors: {},
  formError: null,

  initDraft: (settings) =>
    set({
      draft: {
        tone_preset: settings.tone_preset,
        chat_greeting: settings.chat_greeting ?? "",
        assistant_greeting: settings.assistant_greeting ?? "",
        tone_custom_instructions: settings.tone_custom_instructions ?? "",
      },
      isDirty: false,
      fieldErrors: {},
      formError: null,
    }),

  updateDraft: (patch) =>
    set((state) => ({
      draft: state.draft ? { ...state.draft, ...patch } : state.draft,
      isDirty: true,
    })),

  setFieldErrors: (errors) => set({ fieldErrors: errors }),

  setFormError: (error) => set({ formError: error }),

  resetDraft: () =>
    set({
      draft: null,
      isDirty: false,
      fieldErrors: {},
      formError: null,
    }),
}));
